import Checkbox from "components/checkbox/checkbox";
import FathomIcon from "components/fathomIcon/fathomIcon";
import { AppAction, AppContext } from "helpers/context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./select-layer.module.scss";
import { ReactComponent as MapAnalysisSvg } from "assets/map_analysis.svg";

interface TypeButton {
  id: string;
  title: string;
  disabled: boolean;
  validateStatus: boolean;
  icon: React.FunctionComponent<any>;
  clickDisabled?: boolean;
}

interface Props {
  index: number;
  buttons: TypeButton[];
  // defaultSelect?: string;
  selectedButtons: any[];
  setSelectedButtons: any;
  type: "single" | "multiple" | "shape";
}

function SelectLayer(props: Props) {
  const [context, dispatch] = useContext(AppContext);
  const [t] = useTranslation();
  const selectedButtons = props.selectedButtons;
  const setSelectedButtons = props.setSelectedButtons;

  const handleClick = (buttonTitle: string) => {
    const newSelectedButtons = [...selectedButtons[props.index]];
    const buttonIndex = newSelectedButtons.indexOf(buttonTitle);
    if (buttonIndex >= 0) {
      newSelectedButtons.splice(buttonIndex, 1);
    } else {
      newSelectedButtons.push(buttonTitle);
    }
    selectedButtons[props.index] = newSelectedButtons;
    setSelectedButtons([...selectedButtons]);
  };

  const handleSelectAll = (selectAll: boolean) => {
    let buttonsArr = props.buttons
      .filter(button => !button.disabled)
      .map(button => button.id);
    const newSelectedButtons = !selectAll ? buttonsArr : [];
    selectedButtons[props.index] = newSelectedButtons;
    setSelectedButtons([...selectedButtons]);
  };

  const handleGetAnalySisICon = (button: TypeButton) => {
    let inResult = false;
    if (
      (context.currentMultipleLocations?.id === context.currentMultipleLocationsAnalysed?.id) &&
      (props.type === "multiple")
    ) {
      if (props.index === 0) {
        inResult = !!context.hazardMultipleAnalysedLegends?.find((item) => item.layerId === button.id)
      } else if (props.index === 1) {
        inResult = !!context.climateMultipleAnalysedLegends?.find((item) => item.id === button.id)
      }
    }
    return inResult && <MapAnalysisSvg className="w-[20px] h-[20px] fill-[#0009] ml-[8px] mr-[10px]" />
  }

  const isAllSelected =
    selectedButtons[props.index].length === props.buttons.filter(button => !button.disabled).length;

  const getTranslateKey = (button: TypeButton) => {
    if (props.type === "single" && props.index === 2) {
      return `layerId.futureHazard.${button.id}`;
    }
    if (props.type === "single" && props.index === 3) {
      return `layerId.CRSComponent.${button.id}`;
    }
    return "layerId." + button.id;
  };

  return (
    <div>
      <div className={styles.select}>
        <div className={styles.title}>
          {t(`analyseModal.${props.index === 0 ? "selectLayers" : "selects"}`)}
        </div>
        <div className={styles.checkbox}>
          <div>
            {t("buttons.selectAll")}
          </div>
          <Checkbox
            onChange={() => { }}
            onClick={() => handleSelectAll(isAllSelected)}
            checked={isAllSelected}
          />
        </div>
      </div>
      <div className={`grid grid-cols-2 gap-3.5 ${styles.perils}`}>
        {props.buttons.map((button: TypeButton) =>
          <div
            key={button.id}
            className={
              button.disabled
                ? styles.disabledButton
                : selectedButtons[props.index].includes(button.id)
                  ? styles.activeButton
                  : styles.button
            }
            onClick={() => {
              if (button.clickDisabled) return;
              if (button.validateStatus) {
                if (button.id.includes("Fathom")) {
                  dispatch({
                    type: AppAction.setFathomPermissionDialog,
                    payload: "2"
                  });
                } else {
                  dispatch({
                    type: AppAction.setFathomPermissionDialog,
                    payload: "3"
                  });
                }
              } else if (button.disabled) {
                dispatch({
                  type: AppAction.setFathomPermissionDialog,
                  payload: true
                });
              }

              if (!button.disabled) {
                handleClick(button.id);
              }
            }}
          >
            <div className={styles.inline}>
              <div className={styles.icon}>
                <button.icon className={styles.image} />
              </div>
              {t(getTranslateKey(button))}
            </div>
            <div className={styles.rightIcon}>
              {handleGetAnalySisICon(button)}
              {button.id.includes("Fathom") &&
                <FathomIcon className={styles.premium} />}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SelectLayer;


